import React, { HTMLAttributes, JSXElementConstructor, ReactNode } from 'react';
import './Container.css';

export interface IContainerProps extends HTMLAttributes<any> {
	fluid?: boolean;
	as?: string | JSXElementConstructor<any>;
	ariaLabel?: string;
    children?: string | null | ReactNode;
    className?: string;
}

const Container = ({
	className='',
	fluid = false,
	as = 'div',
	children,
	...rest
}: IContainerProps) => {
	const As: IContainerProps['as'] = as;
	return (
		<As
			className={`Container ${className} ${fluid ? 'fluid' : ''}`}
			{...rest}
		>
			{children}
		</As>
	);
};

export default Container;
